import {inject, injectable} from 'inversify';

import type {BaseDomainFactory} from '../Base/BaseDomain.factory';

import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {BoundAssessmentModel} from './BoundAssessment.model';

@injectable()
export class BoundAssessmentFactory
  implements BaseDomainFactory<BoundAssessmentModel, BoundAssessmentModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: BoundAssessmentModel.Props) {
    return this.modelsRegistry.put(new BoundAssessmentModel(props));
  }
}
